import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SrBox from 'client/components/SrBox';

import './SrCard.less';

export const SR_CARD_FONT_SIZE_SMALL = 'SR_CARD_FONT_SIZE_SMALL';
export const SR_CARD_FONT_SIZE_REGULAR = 'SR_CARD_FONT_SIZE_REGULAR';
const SR_CARD_FONT_SIZE_CLASSNAME_MAPPING = {
  SR_CARD_FONT_SIZE_SMALL: 'font-size-small',
  SR_CARD_FONT_SIZE_REGULAR: 'font-size-regular',
};

export const SR_CARD_CONTENT_TYPE_FORM_REGULAR = 'SR_CARD_CONTENT_TYPE_FORM_REGULAR';
export const SR_CARD_CONTENT_TYPE_FORM_GRID = 'SR_CARD_CONTENT_TYPE_FORM_GRID';
const SR_CARD_CONTENT_TYPE_CLASSNAME_MAPPING = {
  SR_CARD_CONTENT_TYPE_FORM_REGULAR: 'content-type-form-regular',
  SR_CARD_CONTENT_TYPE_FORM_GRID: 'content-type-form-grid',
};

export const SR_CARD_BULLET_COLOR_GREEN = 'SR_CARD_BULLET_COLOR_GREEN';
export const SR_CARD_BULLET_COLOR_PURPLE = 'SR_CARD_BULLET_COLOR_PURPLE';
export const SR_CARD_BULLET_COLOR_YELLOW = 'SR_CARD_BULLET_COLOR_YELLOW';
export const SR_CARD_BULLET_COLOR_BLUE = 'SR_CARD_BULLET_COLOR_BLUE';
export const SR_CARD_BULLET_COLOR_BLACK = 'SR_CARD_BULLET_COLOR_BLACK';
const SR_CARD_BULLET_COLOR_CLASSNAME_MAPPING = {
  [SR_CARD_BULLET_COLOR_GREEN]: 'bulletColorGreen',
  [SR_CARD_BULLET_COLOR_PURPLE]: 'bulletColorPurple',
  [SR_CARD_BULLET_COLOR_YELLOW]: 'bulletColorYellow',
  [SR_CARD_BULLET_COLOR_BLUE]: 'bulletColorBlue',
  [SR_CARD_BULLET_COLOR_BLACK]: 'bulletColorBlack',
};
const SR_CARD_BULLET_COLORS = Object.keys(SR_CARD_BULLET_COLOR_CLASSNAME_MAPPING);

const SrCard = forwardRef(
  (
    {
      color,
      padding,
      noContentPadding,
      header,
      contentType,
      headerSizeType,
      subheader,
      iconUrl,
      maxWidth,
      className,
      overflow,
      children,
      height,
      margin,
      borderRadius,
      isHighlighted,
    },
    ref,
  ) => {
    return (
      <SrBox
        ref={ref}
        className={classnames(className, { highlightAnimation: isHighlighted })}
        styleName={classnames('SrCard', { noContentPadding })}
        padding={padding}
        maxWidth={maxWidth}
        overflow={overflow}
        height={height}
        margin={margin}
        borderRadius={borderRadius}
      >
        {header && (
          <div styleName={classnames('headerContainer', noContentPadding ? 'headerPadding' : null)}>
            <span
              style={{
                backgroundImage: iconUrl ? `url(${iconUrl})` : 'none',
              }}
              styleName={classnames('iconUrl', SR_CARD_BULLET_COLOR_CLASSNAME_MAPPING[color])}
            />
            <span>
              <span styleName="headerTextContainer">
                <span
                  styleName={classnames(
                    'header',
                    SR_CARD_FONT_SIZE_CLASSNAME_MAPPING[headerSizeType],
                  )}
                >
                  {header}
                </span>
                {subheader && <span styleName="subheader">{subheader}</span>}
              </span>
            </span>
          </div>
        )}
        {children && (
          <div
            styleName={classnames(
              'contentContainer',
              !subheader ? 'noSubheader' : null,
              SR_CARD_CONTENT_TYPE_CLASSNAME_MAPPING[contentType],
            )}
          >
            {children}
          </div>
        )}
      </SrBox>
    );
  },
);

SrCard.propTypes = {
  color: PropTypes.oneOf(SR_CARD_BULLET_COLORS),
  contentType: PropTypes.oneOf(Object.keys(SR_CARD_CONTENT_TYPE_CLASSNAME_MAPPING)),
  padding: PropTypes.string,
  noContentPadding: PropTypes.bool,
  header: PropTypes.string,
  headerSizeType: PropTypes.oneOf(Object.keys(SR_CARD_FONT_SIZE_CLASSNAME_MAPPING)),
  subheader: PropTypes.string,
  iconUrl: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  maxWidth: PropTypes.string,
  overflow: PropTypes.string,
  margin: PropTypes.string,
  borderRadius: PropTypes.string,
  isHighlighted: PropTypes.bool,
};

SrCard.defaultProps = {
  color: SR_CARD_BULLET_COLOR_GREEN,
  noContentPadding: false,
  headerSizeType: SR_CARD_FONT_SIZE_REGULAR,
  maxWidth: '900px',
};

SrCard.displayName = 'SrCard';

export default SrCard;
